var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: "searchItem",
              attrs: {
                "config-module": "9211",
                "is-simple-query": false,
                "custom-sim-query-placeholder":
                  _vm.$t("CargoMsg.Cargo_PlsInput") +
                  ":" +
                  _vm.$t("SeaExport.OrderNo2"),
                "custom-search-items": _vm.customSearchItems
              },
              on: {
                "click-more": function(value) {
                  _vm.isAdvancedQuery = value
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.queryHandler
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _vm.source ===
                  _vm.SystemConstants.LOAD_POOL_SOURCE_HOME_PAGE.code
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.generateAssemblyPlan }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_GenerateAssemblyPlan")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.source ===
                  _vm.SystemConstants.LOAD_POOL_SOURCE_DETAIL.code
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addUldItemsToUld }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddToPlan")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { height: "100%" },
                attrs: {
                  "config-module": "202206072",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "show-selected-color": false,
                  "check-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "202206072",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.assemblyPlanDialog.visible
        ? _c("assembly-plan-dialog", {
            attrs: {
              visible: _vm.assemblyPlanDialog.visible,
              form: _vm.assemblyPlanDialog.form,
              "airline-product-down-list": _vm.airlineProductDownList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.assemblyPlanDialog, "visible", $event)
              },
              saveAssemblyPlanSuccess: _vm.saveAssemblyPlanSuccess
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }